export default Object.freeze({
  STANDARD: "one_time_payment",
  RECURRING: "recurring",
});
